import styled from 'styled-components'
import { IconBellMulticolor } from '@blocket/blocket-ui'
import staticFilesUrl from 'constants/staticFiles'

const IconBackground = styled.div`
  background-image: url('${staticFilesUrl}/assets/images/blue_ellipse.svg');
  height: 56px;
  width: 56px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const RotatingBellIcon = styled(IconBellMulticolor)`
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(25deg);
    }
    50% {
      transform: rotate(0deg);
    }
    75% {
      transform: rotate(-25deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  animation: rotation 2s infinite linear;
`

const IconRotatingBell = () => {
  return (
    <IconBackground>
      <RotatingBellIcon width="26px" hight="26px" />
    </IconBackground>
  )
}

export default IconRotatingBell
